import React, { Fragment,useState, useEffect } from 'react';
import {Row, Col, Container} from "reactstrap";
import firebase from "firebase/app";
import firebaseConfig from "./utils/firebaseconfig";
import "firebase/database"
import "firebase/storage"
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Link } from 'react-router-dom';

import {BrowserRouter as Router,Route,Switch} from "react-router-dom";
import { NotFound } from './components/NotFound';
import Auth from './Admin/Auth';
import {AdminContext,GoldContext,SilverContext, ComponentContext, NavContext} from "./Context/Context";
import {SignInContext} from "./Context/Context"
import MainPage from './components/MainPage';
import AdminRings from './Admin/AdminRings';
import AdminNecklace from './Admin/AdminNecklace';
import AdminStirs from './Admin/AdminStirs';
import Cart from './Cart/Cart';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {GoldCost} from './components/goldCost';
import {ContactUs} from './components/ContactUs';
import { Footer } from './components/Footer';
import SignIn  from './User/SignIn';
import  {AdminGoldRate}  from './Admin/AdminGoldRate';
import { OrderStatus } from './Admin/OrderStatus';
import {PlaceOrder} from './components/PlaceOrder';
import { UserOrders } from './User/UserOrders';
import { Orders } from './Admin/Orders';
import AdminCoins from './Admin/AdminCoins';
import { Silver } from './components/Silver';

import AdminChains from './Admin/AdminChains';
import AdminBracelet from './Admin/AdminBracelet';
import AdminSilver from './Admin/AdminSilver';
import {AdminSilverRate} from './Admin/AdminSilverRate';
import Header from './components/Header';
import { Waypoint } from 'react-waypoint';
import PersistentDrawerLeft from './Cart/NavBar';
import  GoldComp from './components/GoldComp';


firebase.initializeApp(firebaseConfig)
const App=()=>{
  const [admin,setAdmin]=useState(false);
  const [signinuser,setSigninuser]=useState();
  const [goldRate,setGoldRate]=useState("");
  const [silverCost,setSilverCost]=useState("");
  const [user,setUser]=useState(null);
  const [comp,setComp]=useState("");
  const [showNav,setShowNav]=useState(false);
  const getGoldRate=async ()=>{
    var goldRef=await firebase.database().ref('/goldrate');
        goldRef.on('value',(snapshot)=>{
            setGoldRate(parseInt(snapshot.val().value));
            console.log(parseInt(snapshot.val().value))
        })
  }
  const getSilverCost=async ()=>{
    var silverRef=await firebase.database().ref('/silverrate');
        silverRef.on('value',(snapshot)=>{
            setSilverCost(parseInt(snapshot.val().value));
            console.log(parseInt(snapshot.val().value))
        })
  }
  useEffect(()=>{getGoldRate();
  getSilverCost();},
  []);

  return(
    <>
    <Router>
    <NavContext.Provider value={{showNav,setShowNav}}>
    <Cart className="navbar"/>
    <SignInContext.Provider value={{signinuser,setSigninuser}}>
    <AdminContext.Provider value={{admin,setAdmin}}>
    <GoldContext.Provider value={{goldRate,setGoldRate}}>
    <SilverContext.Provider value={{silverCost,setSilverCost}}>
    <ComponentContext.Provider value={{comp,setComp}}>
     <Cart className="navbar"/>
    <ToastContainer/>
      <div >
      <Switch>
  <Route exact path="/" component={MainPage}/>
    <Route exact path="/rings" render={({ comp }) => <GoldComp comp={'rings'} mine={true}/>}/>
    <Route exact path="/necklace" render={({ comp }) => <GoldComp comp={'necklace'} mine={true}/>}/>
    <Route exact path="/bracelet" render={({ comp }) => <GoldComp comp={'bracelets'} mine={true}/>}/>
    <Route exact path="/stirs" render={({ comp }) => <GoldComp comp={'stirs'} mine={true}/>}/>
    <Route exact path="/coins" render={({ comp }) => <GoldComp comp={'coins'} mine={true}/>}/>
    <Route exact path="/chains" render={({ comp }) => <GoldComp comp={'chains'} mine={true}/>}/>
    <Route exact path="/silver" component={Silver}/>
    <Route exact path="/auth" component={Auth}/>
      <Route exact path="/auth/rings" component={AdminRings}/>
      <Route exact path="/auth/necklace" component={AdminNecklace}/>
      <Route exact path="/auth/stirs" component={AdminStirs}/>
      <Route exact path="/cart" component={Cart}/>
      <Route exact path="/goldcost" component={GoldCost}/>
      <Route exact path="/contactus" component={ContactUs}/>
      <Route exact path="/auth/orderstatus" component={OrderStatus}/>
      <Route exact path="/orders" component={UserOrders}/>
      <Route exact path="/signin" component={SignIn} />
      <Route exact path="/placeorder" component={PlaceOrder}/>
      <Route exact path="/auth/goldcost" component={AdminGoldRate}/>
      <Route exact path="/auth/silvercost" component={AdminSilverRate}/>
      <Route exact path="/auth/orders" component={Orders}/>
      <Route exact path="/auth/coins" component={AdminCoins}/>
      <Route exact path="/auth/chains" component={AdminChains}/>
      <Route exact path="/auth/bracelets" component={AdminBracelet}/>
      <Route exact path="/auth/silver" component={AdminSilver}/>
      <Route component={NotFound}/>
      </Switch>
      </div>
      </ComponentContext.Provider>
    </SilverContext.Provider>
    </GoldContext.Provider>
    </AdminContext.Provider>
    </SignInContext.Provider>
    </NavContext.Provider>
  </Router>
  </>
    
  )
}
export default App;
